<template>
  <div>
    <el-container>
      <el-header><DHeader></DHeader></el-header>
      <el-container>
        <el-aside width="200px">
          <DAside></DAside>
        </el-aside>
        <el-main> <DHMain></DHMain></el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import DHeader from "./DHeader";
import DAside from "./DAside";
import DHMain from "./DMain.vue";
export default {
  name: "dhome",
  components: { DHeader, DAside, DHMain }
};
</script>
<style scoped>
.el-header {
  background-color: #000;
  color: #ffdd1a;
  text-align: center;
  line-height: 60px;
  padding: 0px;
}

.el-aside {
  text-align: center;
  line-height: 200px;
}

.el-main {
  text-align: left;
}
.el-menu {
  height: 92vh;
  background-color: #000;
}

body > .el-container {
  margin-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/dhome/DHome.vue